import {useQuery} from "react-query";
import {fetchItem} from "../queries/queries-helper.ts";
import ENDPOINTS from "../services/endpoints.ts";
import IpcKeyName from "../models/enums/ipc-key-name.ts";
import StoreyType from "../models/enums/storey-type.ts";
import {IpcStoreyTypeCalcDTO} from "../models/interfaces/dtos/ipc-storey-type-calc-dto.ts";
import addArrayQueryParams from "../utils/add-array-query-params.ts";

const useIpcLocalisationData = (localisationId: number) => useQuery<IpcStoreyTypeCalcDTO | undefined>(
        ['id', localisationId],
        async () => {
            const uri = ENDPOINTS.BOOMER_GET_LOCALISATION_INDICATORS(localisationId);
            const ipcs = [IpcKeyName.RDP, IpcKeyName.CDF, IpcKeyName.PSV, IpcKeyName.RGOS, IpcKeyName.RGOSh];
            const storeyTypes = [StoreyType.All];

            const queryParams = {
                ipcKeyNames: ipcs,
                storeyTypes: storeyTypes
            }

            const finalUri = addArrayQueryParams(uri, queryParams);
            return fetchItem<IpcStoreyTypeCalcDTO>(finalUri);
        }, {
            staleTime: 60 * 60 * 1000 // 1 heure
        }
    )

export default useIpcLocalisationData;